import React, { createContext, useContext, useState, useEffect } from 'react';

const BookmarksContext = createContext();

export const useBookmarks = () => {
  const context = useContext(BookmarksContext);
  if (!context) {
    throw new Error('useBookmarks must be used within a BookmarksProvider');
  }
  return context;
};

export const BookmarksProvider = ({ children }) => {
  const [bookmarks, setBookmarks] = useState(() => {
    const saved = localStorage.getItem('bookmarkedPosts');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('bookmarkedPosts', JSON.stringify(bookmarks));
  }, [bookmarks]);

  const addBookmark = (post) => {
    setBookmarks(prev => {
      if (prev.some(b => b.id === post.id)) {
        return prev; // Already bookmarked
      }
      return [...prev, {
        id: post.id,
        title: post.title,
        excerpt: post.excerpt,
        category: post.category,
        image: post.image,
        date: post.date,
        bookmarkedAt: new Date().toISOString()
      }];
    });
  };

  const removeBookmark = (postId) => {
    setBookmarks(prev => prev.filter(b => b.id !== postId));
  };

  const isBookmarked = (postId) => {
    return bookmarks.some(b => b.id === postId);
  };

  const toggleBookmark = (post) => {
    if (isBookmarked(post.id)) {
      removeBookmark(post.id);
    } else {
      addBookmark(post);
    }
  };

  const clearAllBookmarks = () => {
    setBookmarks([]);
  };

  return (
    <BookmarksContext.Provider value={{
      bookmarks,
      addBookmark,
      removeBookmark,
      isBookmarked,
      toggleBookmark,
      clearAllBookmarks,
      bookmarkCount: bookmarks.length
    }}>
      {children}
    </BookmarksContext.Provider>
  );
};

export default BookmarksContext;
